export const tokenName = 'interpipetoken';

export const saveTokenToStorage = token => localStorage.setItem(tokenName, token);
export const getTokenFromStorage = () => localStorage.getItem(tokenName);
export const removeTokenFromStorage = () => localStorage.removeItem(tokenName);
